export const windowExists = () => typeof window !== 'undefined'
